import Button from "@mostrans/web-components/components/base/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import AdditionalInformation from "./AdditionalInformation";
import BasicInformation from "./BasicInformation";
import Education from "./Education";
import WorkExperience from "./WorkExperience";

function ModalPreviewApplication({
  data,
  confirmationAlert,
  onClose,
  img
}) {
  return (
    <React.Fragment>
      <DialogTitle>
        <h4>Preview Application Form</h4>
      </DialogTitle>
      <DialogContent>
        <BasicInformation data={data} img={img}/>
        <Education data={data} />
        <AdditionalInformation data={data} />
        <WorkExperience data={data} />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose()}
          className="m-2 w-25"
          variant="outlined"
          color="primary"
          startIcon={<span className="material-icons"> arrow_back </span>}
        >
          Back
        </Button>
        <Button
          style={{
            margin: "10px",
            width: "25%",
            height: "3rem",
          }}
          variant="contained"
          color="primary"
          startIcon={<span className="material-icons"> save </span>}
          onClick={(e) => confirmationAlert(e)}
        >
          Submit Application
        </Button>
      </DialogActions>
    </React.Fragment>
  );
}

export default ModalPreviewApplication;
